// src/hooks/AuthContext.jsx
import { createContext, useContext, useState, useCallback, useEffect } from "react";

const TOKEN_KEY    = "cust_token";
const CUSTOMER_KEY = "cust_data";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken]       = useState(() => localStorage.getItem(TOKEN_KEY) || null);
  const [customer, setCustomer] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CUSTOMER_KEY) || "null"); }
    catch { return null; }
  });

  const login = useCallback((newToken, customerData) => {
    localStorage.setItem(TOKEN_KEY,    newToken);
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customerData));
    setToken(newToken);
    setCustomer(customerData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(CUSTOMER_KEY);
    setToken(null);
    setCustomer(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, customer, isLoggedIn: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthContext must be used inside <AuthProvider>");
  return ctx;
}